import add from 'lodash/add';
import toNumber from 'lodash/toNumber';

export default function calculateExclusion(exclusions = [], owner) {
	return exclusions
		.filter(({ ownership }) => owner === ownership)
		.reduce((total, { amount }) => add(total, toNumber(amount)), 0);
}
